import React, { useEffect, useRef, useState } from 'react';
import './new-info-form.styles.scss'
import TextEditorNoLib from '../text-editor-no-lib/text-editor-no-lib.component';
import FullPageLoader from '../loader/full-page-loader.component';
import { getOptimizedImageNoCrop } from '@/utils/getOptimizedBlob';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { ModalAlert } from '../modal/modal.component';
import { useSelector } from 'react-redux';

const NewInfoForm = ({
  saveSetData,
  questionSetData,
  setAlertMessage, 
  informationToEdit,
  closeForm
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const [formData, setFormData] = useState({});
  const [ loading, setLoading ] = useState(false);
  const [ htmlContent, setHtmlContent ] = useState('Insert information here...');
  const dataRef = useRef({});

  useEffect(() => {
    if (!informationToEdit) return; 
    dataRef.current = { ...informationToEdit };
    setFormData(dataRef.current);
    setHtmlContent(informationToEdit.infoContent ?? 'Insert information here...');
  }, [informationToEdit]);

  function saveData(key, value) {
    dataRef.current = {
      ...dataRef.current,
      [key]: value,
    }
    setFormData(dataRef.current);
    console.log('dataRef.current', dataRef.current);
  }

  async function handleImageUpload(file) {
    setLoading(true);
    if (file.type.includes('gif')) {
      setAlertMessage('GIF images are not supported. Please upload a JPG or PNG image.');
      setLoading(false);
      return;
    }
    const optimizedFile = await getOptimizedImageNoCrop(file, 200, 800);
    console.log('optimizedFile', optimizedFile);
    if (!optimizedFile) {
      setAlertMessage('There was an error processing the image. Please try a different image or try again later.');
      setLoading(false);
      return;
    }
    const reader = new FileReader();
    const imageUrl = await new Promise((resolve, reject) => {
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1];
        const uploadRes = await UseCloudFunction(
          'uploadFileToStorage',
          {
            'fileDataBase64': base64String,
            'fileName': file.name,
            'fileType': file.type,
            'folder': userProfile.cst_key,
            'cstKey': userProfile.cst_key
          }
        )
        console.log(uploadRes);
        setLoading(false);
        if (uploadRes.error) {
          setAlertMessage(`Error uploading file: ${uploadRes.error}`);
          reject(uploadRes.error);
        }
        resolve(uploadRes.url);
      }
      reader.readAsDataURL(optimizedFile);
    });
    return imageUrl;
  }

  function saveQuestionToSet() {
    // console.log('Save Question to Set', formData);
    const tempData = { ...dataRef.current };
    if (!tempData.prompt) {
      setAlertMessage('Please include a title for the Information Block.');
      return;
    }
    if (!tempData.infoContent) {
      setAlertMessage('Please include some content to add to the Information Block.');
      return;
    }
    tempData.shortTitle = tempData.prompt;
    tempData.type = 'info';

    const tempQuestions = questionSetData.questions || {};
    if (!tempData.id) {
      tempData.id = new Date().getTime() + '_q';
      const existingCount = Object.keys(tempQuestions).length;
      tempData.order = existingCount + 1;
    }
    saveSetData('questions', { ...tempQuestions, ...{ [tempData.id]: tempData } });
    dataRef.current = {};
    setFormData(dataRef.current);
  }

  // function closeForm() {
  //   dataRef.current = {};
  //   setFormData(dataRef.current);
  //   setCreateQuestionOpen(false);
  // }

  return (
    <div className='form-builder_new-info-form'>
      <div className='form-builder_field small'>
        <label>Information Block Title</label>
        <input
          type="text"
          value={formData.prompt ?? ''}
          onChange={e => saveData('prompt', e.target.value)} />
      </div>
      <div className='form-builder_field-checkbox small'>
        <label>
            Display Title
        </label>
        <input
            type="checkbox"
            checked={formData.showTitle ?? true}
            onChange={e => saveData('showTitle', e.target.checked)} />
        
      </div>
      {
        (htmlContent) &&
      <TextEditorNoLib
        onChange={e => saveData('infoContent', e)}
        initialValue={formData.infoContent ? formData.infoContent : htmlContent}
        handleImageUpload={handleImageUpload} />
      }
      {/* <div className='g-space-1'></div> */}
      <div className='form-builder_buttons'>
        <button
          className='form-builder_button med-btn'
          onClick={() => closeForm()}>
          Cancel
        </button>
        <button
          className='form-builder_button med-btn'
          onClick={() => saveQuestionToSet()}>Save Information Block</button>
      </div>
      <FullPageLoader show={loading} />
    </div>
  )
}

export default NewInfoForm